import { render, staticRenderFns } from "./AnimationPage.vue?vue&type=template&id=c97e8e7a&scoped=true"
import script from "./AnimationPage.vue?vue&type=script&lang=js"
export * from "./AnimationPage.vue?vue&type=script&lang=js"
import style0 from "./AnimationPage.vue?vue&type=style&index=0&id=c97e8e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97e8e7a",
  null
  
)

export default component.exports